var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.75,
    height: 13.75,
    viewBox: "0 0 13.75 13.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "network-wired-svgrepo-com",
    d: "M0,6.375H12.75M6.375,9.208V6.375m-3.9,0V3.542m7.792,2.833V3.542M5.029,9.208H7.721a1.76,1.76,0,0,1,.747.077.708.708,0,0,1,.31.31,1.76,1.76,0,0,1,.077.747v1.275a1.76,1.76,0,0,1-.077.747.708.708,0,0,1-.31.31,1.76,1.76,0,0,1-.747.077H5.029a1.76,1.76,0,0,1-.747-.077.708.708,0,0,1-.31-.31,1.76,1.76,0,0,1-.077-.747V10.342A1.76,1.76,0,0,1,3.973,9.6a.708.708,0,0,1,.31-.31A1.76,1.76,0,0,1,5.029,9.208ZM8.925,0h2.692a1.76,1.76,0,0,1,.747.077.708.708,0,0,1,.31.31,1.76,1.76,0,0,1,.077.747V2.408a1.76,1.76,0,0,1-.077.747.708.708,0,0,1-.31.31,1.76,1.76,0,0,1-.747.077H8.925a1.76,1.76,0,0,1-.747-.077.708.708,0,0,1-.31-.31,1.76,1.76,0,0,1-.077-.747V1.133A1.76,1.76,0,0,1,7.869.387a.708.708,0,0,1,.31-.31A1.76,1.76,0,0,1,8.925,0ZM1.133,0H3.825a1.76,1.76,0,0,1,.747.077.708.708,0,0,1,.31.31,1.76,1.76,0,0,1,.077.747V2.408a1.76,1.76,0,0,1-.077.747.708.708,0,0,1-.31.31,1.76,1.76,0,0,1-.747.077H1.133a1.76,1.76,0,0,1-.747-.077.708.708,0,0,1-.31-.31A1.76,1.76,0,0,1,0,2.408V1.133A1.76,1.76,0,0,1,.077.387a.708.708,0,0,1,.31-.31A1.76,1.76,0,0,1,1.133,0Z",
    transform: "translate(13.25 0.5) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.891041a3d9c5437b7ffce23f9402601d.svg";
export { ForwardRef as ReactComponent };